import { DateTime } from 'luxon'
import { useDateManager } from '@/shared/composables/useDateManager.js'

export const useFormDates = () => {
  const { formatDate } = useDateManager()
  const getDayFromDateString = (string) => {
    return string ? Number(string.split('-')[2]) : ''
  }
  const getMonthFromDateString = (string) => {
    return string ? Number(string.split('-')[1]) : ''
  }
  const getYearFromDateString = (string) => {
    return string ? Number(string.split('-')[0]) : ''
  }
  const formatFormDate = (year, month, day = 1) => {
    return formatDate(
      DateTime.now().set({
        year: Number(year),
        month: Number(month),
        day: Number(day),
      }),
      'yyyy-MM-dd',
    )
  }

  return {
    getDayFromDateString,
    getMonthFromDateString,
    getYearFromDateString,
    formatFormDate,
  }
}
